import React from 'react';
import { Switch } from 'react-router-dom';
import { ProviderContractsList } from '../../contextsProperty/ContextContractsList';
import ProtectedRoute from '../../../utils/ProtectedRoute';
import StaticRatesContracts from './StaticRatesContracts';
import {
    AppSections,
    AppSectionsCore,
} from '../../../types/appConfiguration/appConfigTypes';
import StaticRatesContractDetail from './detail/StaticRatesContractDetail';
import { ProviderContractDetail } from '../../contextsProperty/ContextContractDetail';

type StaticRatesContainerProps = {
    match: {
        path: string;
    };
};

const StaticRatesContainer = ({ match }: StaticRatesContainerProps) => {
    return (
        <ProviderContractsList>
            <Switch>
                <ProtectedRoute
                    path={`${match.path}/:encodedIdContract`}
                    render={() => (
                        <ProviderContractDetail>
                            <StaticRatesContractDetail />
                        </ProviderContractDetail>
                    )}
                    section={AppSections.CORE}
                    page={AppSectionsCore.CONTRACTS}
                />
                <ProtectedRoute
                    path={`${match.path}`}
                    render={() => <StaticRatesContracts />}
                    section={AppSections.CORE}
                    page={AppSectionsCore.CONTRACTS}
                />
            </Switch>
        </ProviderContractsList>
    );
};

export default StaticRatesContainer;
